import type {
  GroupRule,
  GroupType,
  RuleBuilderRule,
  RulePath,
  ThresholdRule,
} from './types';
import { ruleType } from './types';
import { generatePublicId } from 'flow/store/engine/utils';

export function buildGroupRule(args: {
  groupType: GroupType;
  children?: RuleBuilderRule[];
  rulePath?: RulePath;
  id?: ReturnType<typeof generatePublicId>;
  isAmbiguous?: boolean;
}): GroupRule {
  const {
    children, groupType, isAmbiguous, rulePath, id,
  } = args;

  return {
    id: id || generatePublicId(ruleType.group),
    type: ruleType.group,
    data: {
      groupType,
      children: children || [],
      isAmbiguous: isAmbiguous || false,
      path: rulePath || [],
    },
  };
}

export function buildThresholdRule(args: {
  thresholdId: string;
  rulePath?: RulePath;
}): ThresholdRule {
  const { thresholdId, rulePath } = args;

  return {
    id: thresholdId,
    type: ruleType.threshold,
    data: {
      path: rulePath || [],
    },
  };
}
